export default "__VITE_ASSET__0VbEpNLy__"